<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { FIELD_CLASS } from '../constants';
import FormField from './FormField.vue';

// An optional reason for withdrawing an offer, cancelling a visit or marking a
// no-show. The page makes the call so a refusal (a no-show before the visit's
// start time) can be shown here through `error`.
export default {
  name: 'VisitReasonModal',
  components: { BaseModal, FormField },
  props: {
    action: { type: String, required: true },
    error: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
  },
  emits: ['close', 'confirm'],
  data() {
    return { fieldClass: FIELD_CLASS, reason: '' };
  },
};
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>
      {{ $t(`CO_LIVING.TICKETS.VISIT_ACTIONS.${action.toUpperCase()}`) }}
    </template>
    <form
      class="grid grid-cols-1 gap-4"
      data-testid="co-living-visit-reason-form"
      @submit.prevent="$emit('confirm', reason.trim())"
    >
      <FormField
        :label="$t('CO_LIVING.TICKETS.BOOKING.REASON')"
        for-id="co-living-visit-reason"
        :error="error"
      >
        <textarea
          id="co-living-visit-reason"
          v-model="reason"
          rows="3"
          maxlength="1000"
          :class="fieldClass"
          data-testid="co-living-visit-reason"
        />
      </FormField>
      <div class="flex justify-end gap-3">
        <woot-button variant="clear" type="button" @click="$emit('close')">
          {{ $t('CO_LIVING.COMMON.CANCEL') }}
        </woot-button>
        <woot-button
          type="submit"
          :is-loading="isLoading"
          data-testid="co-living-visit-reason-confirm"
        >
          {{ $t(`CO_LIVING.TICKETS.VISIT_ACTIONS.${action.toUpperCase()}`) }}
        </woot-button>
      </div>
    </form>
  </BaseModal>
</template>
